module.exports = __webpack_public_path__ + "img/bauen40.34acdb80.jpg";